export default __webpack_public_path__ + "static/do-fade-slide-flag-c72d48e4545bf5ca86bc5dbf3a89f6caaaa139064cf3639f82ccd9b0f4b71e5b.png";